(function () {
  function getOverlay() {
    return document.querySelector('[data-search-overlay]');
  }

  function openSearch() {
    const overlay = getOverlay();
    if (!overlay) return;

    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('search-open');

    const input = overlay.querySelector('input[name="q"]');
    if (input) input.focus();
  }

  function closeSearch() {
    const overlay = getOverlay();
    if (!overlay) return;

    overlay.hidden = true;
    document.body.style.overflow = '';
    document.body.classList.remove('search-open');
  }

  document.addEventListener('click', function (event) {
    const openTrigger = event.target.closest('[data-open-search]');
    if (openTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openSearch();
      return;
    }

    const closeTrigger = event.target.closest('[data-close-search]');
    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
      return;
    }

    const overlay = getOverlay();
    if (!overlay || overlay.hidden) return;

    if (event.target === overlay) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (event) {
    const overlay = getOverlay();
    if (!overlay || overlay.hidden) return;

    if (event.key === 'Escape') {
      closeSearch();
    }
  });
})();